import React from 'react';

import type { ImmutableEntity, Langcodes } from '@uncinc/react-drupal-core/types';
import { CoreLink } from '@uncinc/react-drupal-core';
import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DEFAULT_LANGUAGE } from '../../../../config/constants';
import { NodeVacancy } from '../../../../types/uncinc_profile/nodes';
import { translateEmploymentTypes } from '../../../../helpers/translatedEmploymentTypes';

import './style.scss';

interface NodeVacancyTeaserProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeVacancy>;
}

const NodeVacancyTeaser: React.FC<NodeVacancyTeaserProps> = ({ entity }) => {
  const { t } = useTranslation();
  const vacancy = entity.toJS();
  const lang = vacancy.langcode[0]?.value || DEFAULT_LANGUAGE;
  const andString = lang === DEFAULT_LANGUAGE ? ' en ' : ' and ';
  const title = vacancy.title[0].value;
  const summary = vacancy.body[0]?.summary;
  const language = useSelector<Immutable.Map<any, any>>((state) => state.getIn(['ui', 'language']));
  const translatedEmploymentTypes = translateEmploymentTypes(
    vacancy.field_employment_types,
    lang,
  );

  const link = vacancy.paths[language as Langcodes];

  return (
    <div className="NodeVacancyTeaser col-12 col-md-6">
      <CoreLink
        className="NodeVacancyTeaser__link"
        href={link}
        aria-label={`${t('content_types.vacancy.view')} ${title}`}
      >
        <div className="NodeVacancyTeaser__content">

          <div className="NodeVacancyTeaser__content__text">
            <div className="NodeVacancyTeaser__content__employmentTypes">
              {translatedEmploymentTypes.map((type, i) => (
                <span>
                  {type}
                  {i < translatedEmploymentTypes.length - 2 && ', '}
                  {i === translatedEmploymentTypes.length - 2 && andString}
                </span>
              ))}
            </div>
            <h3>{title}</h3>
            <span>{summary}</span>
          </div>

          <div className="NodeVacancyTeaser__linkbutton">
            <CoreLink
              className="link--text"
              href={link}
              aria-label={`${t('content_types.vacancy.view')} ${title}`}
              // @ts-ignore
              tabindex={-1}
            >
              {t('content_types.vacancy.view')}
              <Icon name="arrow_forward" />
            </CoreLink>
          </div>

        </div>
      </CoreLink>
    </div>
  );
};

export default NodeVacancyTeaser;
